"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var numberField = function numberField(value) {
  if (!['number', 'string'].includes(_typeof(value)) || value === '') return;
  var number = Number(value);
  if (Number.isNaN(number)) return;
  return Number(number.toFixed(2));
};
var _default = exports["default"] = numberField;